import React, { Component } from 'react';
import contactUs from './contactUs.png';
import {Modal, Button} from 'react-bootstrap';

class Footer extends Component {

  constructor(props, context) {
    super(props, context);


    this.handleShow = this.handleShow.bind(this);
    this.handleClose = this.handleClose.bind(this);
    this.state = {
      show: false
    };




  }

  handleClose() {
    this.setState({ show: false });
  }

  handleShow() {
    this.setState({ show: true });
  }
  render() {
    return (
      <footer>
        <center>
              <p>Copyright &copy; Mauersberger 2024. All rights reserved.</p>
            </center>
      <Button className="contactUs" onClick={() => {this.handleShow();}} >
      <div className="contactUs"><img src={contactUs} alt="Contact Us"/><center><h3>Contact Us!</h3></center></div>
      </Button>
      <Modal show={this.state.show} onHide={this.handleClose} >
            <Modal.Header closeButton>
              <Modal.Title>Gehen Sie mit uns den nächsten Schritt!</Modal.Title>
            </Modal.Header>
            <Modal.Body>
              
              <center>
                <address className="text-center">
                  <strong>Mauersberger Industrievertretungen e.K.</strong><br/>
                    Siedlerstrasse 8<br/>
                      90574 Rosstal<br/><br/>
                  <abbr title="Phone">Telefon:</abbr> <a href="callto:00499127903866">(+49) 9127 903866</a><br/>
                  <abbr title="Mail">Mail:</abbr> <a href="mailto:info@mauersberger-vertrieb.de?subject=Anfrage zu">info@mauersberger-vertrieb.de</a><br/>
                </address>
                </center>
                  
            </Modal.Body>
            <Modal.Footer>
              <Button onClick={this.handleClose}>Schließen</Button>
            </Modal.Footer>
          </Modal>

      </footer>
    );
  }
}

export default Footer;



// WEBPACK FOOTER //
// ./src/components/footerComponents/footer.js